import { DownloadFileModal, ModalId } from '../../../../features/ui'
import { DataType } from '../../../../tables'
import { PaymentOrder, CreditPayment } from '../../../administration'
import { SalePaymentItem } from '../../../sales'

type Props = {
    operation?: PaymentOrder | CreditPayment | SalePaymentItem
}

export const DownloadReceiptModal = (props: Props) => {
    const { operation } = props

    return (
        <DownloadFileModal
            modalId={ModalId.DOWNLOAD_RECEIPT}
            dataType={operation}
            fileProp={'receiptUrl' as keyof DataType}
            title="Descargar Comprobante"
        />
    )
}
